import * as React from "react";
import { useProvider } from "../Context";

const initialState = {
  token: null,
  user: {},
  groups: [],
  mediaGroups: [],
  maxGroups: 0,
  maxUsers: 0,
  maxWordsAnd: 0,
  maxWordsNot: 0,
  maxWordsOr: 0,
  activeGroup: 0,
  activeMediaGroup: 0,
  informationUrl: {title: null, desc: null, url: null},
  informations: [],
};

function reducer(state, { type, payload }) {
  switch (type) {
    case "set":
      return { ...state, ...payload };
    case "setUser":
      return { ...state, user: payload };
    case "setTokenResult":
      return { ...state, token: payload };
    default:
      throw new Error("Action type not found");
  }
}

export function useAuthReducer() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return {
    state,
    dispatch,
  };
}

export default function () {
  const {
    auth: { state, dispatch },
  } = useProvider();

  function login({ user, token }) {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", token);
    dispatch({ type: "set", payload: { user, token } });
  }

  function logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    dispatch({
      type: "set",
      payload: {
        token: null,
        user: {},
        groups: [],
        mediaGroups: [],
        maxGroups: 0,
        maxUsers: 0,
        maxWordsAnd: 0,
        maxWordsNot: 0,
        maxWordsOr: 0,
        activeGroup: 0,
        activeMediaGroup: 0,
        informationUrl: {title: null, desc: null, url: null},
        informations: [],
      },
    });
  }

  function deleteGroup(id) {
    const fiterd = state.groups.filter((group) => {
      return group.id !== id;
    });

    dispatch({
      type: "set",
      payload: {
        groups: fiterd,
        activeGroup: fiterd[0] ? fiterd[0].id : 0,
      },
    });
  }

  function setGroups(data, meta) {
    const groups = data;
    const maxGroups = meta.max_groups;
    const maxUsers = meta.max_users;
    const maxWordsAnd = meta.max_words_and;
    const maxWordsNot = meta.max_words_not;
    const maxWordsOr = meta.max_words_or;

    let activeGroup = state.activeGroup;
    if (!activeGroup && data.length > 0) {
      activeGroup = data[0].id;
    }

    dispatch({
      type: "set",
      payload: {
        groups,
        maxGroups,
        maxUsers,
        maxWordsAnd,
        maxWordsNot,
        maxWordsOr,
        activeGroup: activeGroup,
      },
    });
  }

  function setGroup(group) {
    const concatGroups = [...state.groups, group];
    dispatch({
      type: "set",
      payload: {
        groups: concatGroups,
        activeGroup: group.id,
      },
    });
  }
  function setMediaGroups(data) {
    const mediaGroups = data;

    let activeMediaGroup = state.activeMediaGroup;
    if (!activeMediaGroup && data.length > 0) {
      activeMediaGroup = data[0].id;
    }

    dispatch({
      type: "set",
      payload: {
        mediaGroups,
        activeMediaGroup: activeMediaGroup,
      },
    });
  }

  function setMediaGroup(mediaGroup) {
    const concatMediaGroups = [...state.mediagroups, mediaGroup];
    dispatch({
      type: "set",
      payload: {
        mediaGroups: concatMediaGroups,
        activeMediaGroup: mediaGroup.id,
      },
    });
  }

  function setInformationUrl(informationUrl) {
    dispatch({
      type: "set",
      payload: {
        informationUrl: informationUrl,
      },
    });
  }

  function setInformations(informations) {
    dispatch({
      type: "set",
      payload: {
        informations: informations,
      },
    });
  }

  return {
    state: state,
    dispatch: dispatch,
    login,
    logout,
    setGroup,
    setGroups,
    setMediaGroup,
    setMediaGroups,
    deleteGroup,
    setInformationUrl,
    setInformations,
  };
}
